export default "__VITE_PUBLIC_ASSET__f7256245__"